<template>
  <component
    :is="wrapperComponent"
    :offset-top="offsetTop"
    :offset-bottom="offsetBottom"
    :offset-right="offsetRight"
    :offset-left="offsetLeft"
    :container="container"
    :x-axis-fixed="xFixed"
    @on-change="handleAffixStateChange"
  >
    <div :class="`${prefixAnchorClass}-wrapper`" :style="wrapperStyle">
      <div :class="`${prefixAnchorClass}-list`">
        <div :class="`${prefixAnchorClass}-ink`">
          <span v-show="showInk" :class="`${prefixAnchorClass}-ink-ball`" :style="{top: `${inkTop}px`}"></span>
        </div>
        <slot></slot>
      </div>
    </div>
  </component>
</template>
<script>
import {
  scrollTop,
  findComponentsDownward,
  sharpMatcherRegx
} from '../../utils/assist'
import * as constants from '../../utils/constants'
const PREFIX_ANCHOR_CLASS = `${constants.PREFIX_CLASS}anchor`
export default {
  name: 'TAnchor',
  provide() {
    return {
      anchorCom: this
    }
  },
  props: {
    affix: {
      type: Boolean,
      default: true
    },
    offsetTop: {
      type: Number,
      default: 0
    },
    offsetBottom: {
      type: Number,
      default: 0
    },
    offsetRight: {
      type: Number,
      default: 0
    },
    offsetLeft: {
      type: Number,
      default: 0
    },
    bounds: {
      type: Number,
      default: 5
    },
    container: {
      type: [String, Object],
      default: null
    },
    showInk: {
      type: Boolean,
      default: false
    },
    scrollOffset: {
      type: Number,
      default: 0
    },
    xFixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isAffixed: false, // current affixed state
      inkTop: 0,
      animating: false, // if is scrolling now
      currentLink: '', // current show link =>  #href -> currentLink = #href
      currentId: '', // current show title id =>  #href -> currentId = href
      scrollContainer: null,
      scrollElement: null,
      titlesOffsetArr: [],
      wrapperTop: 0,
      upperFirstTitle: true
    }
  },
  computed: {
    wrapperComponent() {
      return this.affix ? 'TAffix' : 'div'
    },
    prefixAnchorClass() {
      return PREFIX_ANCHOR_CLASS
    },
    wrapperStyle() {
      return {
        maxHeight: this.offsetTop
          ? `calc(100vh - ${this.offsetTop}px)`
          : '100vh'
      }
    },
    containerIsWindow() {
      return this.scrollContainer === window
    }
  },
  watch: {
    $route() {
      this.handleHashChange()
      this.$nextTick(() => {
        this.handleScrollTo()
      })
    },
    container() {
      this.init()
    },
    currentLink(newHref, oldHref) {
      this.$emit('on-change', newHref, oldHref)
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.removeListener()
  },
  methods: {
    handleAffixStateChange(state) {
      this.isAffixed = this.affix && state
    },
    /**
     * conatiner的scroll事件回调函数
     *  */
    handleScroll(e) {
      if (this.titlesOffsetArr.length) {
        this.upperFirstTitle =
        e.target.scrollTop < this.titlesOffsetArr[0].offset
      }
      if (this.animating) return
      this.updateTitleOffset()
      const scrollTop =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        e.target.scrollTop
      this.getCurrentScrollAtTitleId(scrollTop)
    },
    /**
     * 获取地址栏上的hash值
     * 由点击anchor-link触发
     */
    handleHashChange() {
      const url = window.location.href
      const sharpLinkMatch = sharpMatcherRegx.exec(url)
      if (!sharpLinkMatch) return
      this.currentLink = sharpLinkMatch[0]
      this.currentId = sharpLinkMatch[1]
    },
    handleScrollTo() {
      /**
       *  获取锚点元素对应的内容区
       * */
      const anchor = document.getElementById(this.currentId)
      /**
       *  获取锚点元素
       * */
      const currentLinkElementA = document.querySelector(
        `a[data-href='${this.currentLink}']`
      )
      let offset = this.scrollOffset
      if (currentLinkElementA) {
        offset = parseFloat(
          currentLinkElementA.getAttribute('data-scroll-offset')
        )
      }
      if (!anchor) return
      const offsetTop = this.getElementTop(anchor) - this.wrapperTop - offset
      if (this.animating) return
      this.animating = true
      scrollTop(
        this.scrollContainer,
        this.scrollElement.scrollTop,
        offsetTop,
        600,
        () => {
          this.animating = false
        }
      )
      this.handleSetInkTop()
    },
    handleSetInkTop() {
      const currentLinkElementA = document.querySelector(
        `a[data-href='${this.currentLink}']`
      )
      if (!currentLinkElementA) return
      const elementATop = currentLinkElementA.offsetTop
      const top = elementATop < 0 ? this.offsetTop : elementATop
      this.inkTop = top
    },
    updateTitleOffset() {
      const links = findComponentsDownward(this, 'TAnchorLink').map(link => {
        return link.href
      })
      const idArr = links.map(link => {
        return link.split('#')[1]
      })
      let offsetArr = []
      idArr.forEach(id => {
        const titleEle = document.getElementById(id)
        if (titleEle) {
          offsetArr.push({
            link: `#${id}`,
            offset: this.getElementTop(titleEle) - this.getElementTop(this.scrollElement)
          })
        }
      })
      this.titlesOffsetArr = offsetArr
    },
    getElementTop(element) {
      var actualTop = element.offsetTop
      var current = element.offsetParent
      while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }
      return actualTop
    },
    getCurrentScrollAtTitleId(scrollTop) {
      let i = -1
      let len = this.titlesOffsetArr.length
      let titleItem = {
        link: '#',
        offset: 0
      }
      scrollTop += this.bounds
      while (++i < len) {
        let currentEle = this.titlesOffsetArr[i]
        let nextEle = this.titlesOffsetArr[i + 1]
        if (
          scrollTop >= currentEle.offset &&
          scrollTop < ((nextEle && nextEle.offset) || Infinity)
        ) {
          titleItem = this.titlesOffsetArr[i]
          break
        }
      }
      this.currentLink = titleItem.link
      this.handleSetInkTop()
    },
    /**
     * 判断容器是自定义还是window
     */
    getContainer() {
      this.scrollContainer = this.container
        ? typeof this.container === 'string'
          ? document.querySelector(this.container)
          : this.container
        : window
      this.scrollElement = this.container
        ? this.scrollContainer
        : document.documentElement || document.body
    },
    /**
     * 解除元素绑定的{ onscroll , onhashchange }事件
     */
    removeListener() {
      if (this.scrollContainer) {
        this.scrollContainer.removeEventListener('scroll', this.handleScroll)
      }
      window.removeEventListener('hashchange', this.handleHashChange)
    },
    init() {
      /**
       * 获取hash值
       */
      this.handleHashChange()
      this.$nextTick(() => {
        this.removeListener()
        this.getContainer()
        /**
       * 当前container距离顶部的距离
       */
        this.wrapperTop = this.containerIsWindow
          ? 0
          : this.scrollElement.offsetTop
        this.handleScrollTo()
        this.handleSetInkTop()
        this.updateTitleOffset()
        if (this.titlesOffsetArr.length) {
          this.upperFirstTitle =
          this.scrollElement.scrollTop < this.titlesOffsetArr[0].offset
        }
        this.scrollContainer.addEventListener('scroll', this.handleScroll)
        this.$emit('getContainer', this.scrollContainer)
        window.addEventListener('hashchange', this.handleHashChange)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/anchor/anchor.vue